import React from 'react';
import { Page } from '../Page';
import { Heart, Brain, Shield } from 'lucide-react';
export function SupplementOmega3() {
  return <Page pageNumber={17} variant="light" data-id="element-3280">
      <div className="flex h-full gap-10" data-id="element-3281">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3282">
          <img src="https://cdn.magicpatterns.com/uploads/3KbmboHJcX9JxXqrqDKoJB/pasted-image.png" alt="Thorne Omega-3 with CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-3283" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3284">
          <div className="mb-6 pt-4" data-id="element-3285">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3286">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3287">
              Omega-3 with CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3288">
              Anti-inflammatory + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3289" />
          </div>

          <div className="mb-8" data-id="element-3290">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3291">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3292">
              Rapid weight loss triggers an inflammatory response throughout the
              body. Omega-3 fatty acids (EPA + DHA) support a healthy
              inflammatory response, protect cardiovascular health, and maintain
              brain function during caloric deficit. The added CoQ10 enhances
              absorption and provides synergistic cellular energy support.
            </p>
          </div>

          <div className="mb-8" data-id="element-3293">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3294">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3295">
              <li className="flex gap-2" data-id="element-3296">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3297" />
                <span data-id="element-3298">
                  Supports cardiovascular health, promoting healthy blood vessel
                  function, cholesterol, and triglyceride levels
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3299">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3300" />
                <span data-id="element-3301">
                  Promotes a healthy inflammatory response during the metabolic
                  stress of weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3302">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3303" />
                <span data-id="element-3304">
                  Supports brain function and protects against oxidative stress
                  during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3305">
                <span className="text-tealslate shrink-0" data-id="element-3306">•</span>
                <span data-id="element-3307">
                  Two supplements in one, molecularly distilled fish oil + CoQ10
                  for enhanced absorption, NSF Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3308">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3309">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3310">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3311">
                <strong data-id="element-3312">1 gelcap, 2-3 times daily</strong> with meals
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3313">
                450mg EPA + 180mg DHA + 30mg CoQ10 per gelcap • 90 gelcaps per
                bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3314">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3315" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3316">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}